import { render, staticRenderFns } from "./my-message.vue?vue&type=template&id=b0436d60&scoped=true"
import script from "./my-message.vue?vue&type=script&lang=js"
export * from "./my-message.vue?vue&type=script&lang=js"
import style0 from "./my-message.vue?vue&type=style&index=0&id=b0436d60&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0436d60",
  null
  
)

export default component.exports